import { LoggedUser } from './session-decode';

/** `integrador === true`. */
export function isIntegrator(user: LoggedUser | null): boolean {
  return user?.integrador === true;
}

/** `contas` ausente ou de tamanho `0`. */
export function isDistributor(user: LoggedUser | null): boolean {
  if (!user) {
    return false;
  }

  return !user.contas || user.contas.length === 0;
}

/** Integrador ou sem contas — usuário para o qual não se carrega a pessoa logada. */
export function isIntegratorOrDistributor(user: LoggedUser | null): boolean {
  if (!user) {
    return false;
  }

  return isIntegrator(user) || isDistributor(user);
}

/** `superUsuario === true`. */
export function isSuperUser(user: LoggedUser | null): boolean {
  return user?.superUsuario === true;
}
